export default "__VITE_ASSET__2Wtk685A__"